import { InjectionToken } from '@angular/core';

import { CommonsConfigEnvironment } from '../commons';

export const CONFIG_ENVIRONMENT = new InjectionToken<CommonsConfigEnvironment>('CONFIG_ENVIRONMENT_TOKEN');
